module.exports = __webpack_public_path__ + "static/img/dummy_pepsiM.93d63ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drink/dummy_pepsiM.png
// module id = vfFJ
// module chunks = 1